import { type ReactNode } from "react";
import Status from "../UI/Status";
import Text from "../UI/Text.tsx";
import type { EditorVariable } from "./VariableNode";
import styles from "./VariablePicker.module.css";
import { Button } from "@base-ui/react/button";
// @ts-expect-error pure js
import { classnames } from "../../utils";

interface Props {
  available?: ReadonlyArray<EditorVariable>;
  onInsert: (key: string) => void;
  label?: ReactNode;
  className?: string;
}

export default function VariablePicker({
  available,
  onInsert,
  label,
  className,
}: Props) {
  if (!available || available.length === 0) return null;
  return (
    <div className={classnames(styles.container, className)}>
      {label && (
        <Text variant="deci" color="muted">
          {label}
        </Text>
      )}
      <div className={styles.row}>
        {available.map((v) => (
          <Button
            key={v.key}
            className={styles.button}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onInsert(v.key)}
          >
            <Status as="span" color="info" text={v.label} />
          </Button>
        ))}
      </div>
    </div>
  );
}
